<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row pt-2">
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Glaswolle</span>
          <button type="button"
            v-for="(item, index) in items.glasswoll"
            :key="'Glaswolle-' + index"
            :class="['btn btn-sm btn-outline-filter btn-insulation', filterUiState('compartmentInsulation', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Steinwolle</span>
          <button type="button"
            v-for="(item, index) in items.rockwoll"
            :key="'rockwoll-' + index"
            :class="['btn btn-sm btn-outline-filter btn-insulation', filterUiState('compartmentInsulation', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Zellulose</span>
          <button type="button"
            v-for="(item, index) in items.cellulose"
            :key="'cellulose-' + index"
            :class="['btn btn-sm btn-outline-filter btn-insulation', filterUiState('compartmentInsulation', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-3">
          <span class="d-block pb-2">Holzwolle</span>
          <button type="button"
            v-for="(item, index) in items.woodwoll"
            :key="'woodwoll-' + index"
            :class="['btn btn-sm btn-outline-filter btn-insulation', filterUiState('compartmentInsulation', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionCompartmentInsulation',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Gefachdämmung',
      items: {
        glasswoll: [
          { title: '80 mm', value: 'cigw-80' },
          { title: '100 mm', value: 'cigw-100' },
          { title: '140 mm', value: 'cigw-140' },
          { title: '160 mm', value: 'cigw-160' },
          { title: '180 mm', value: 'cigw-180' },
          { title: '200 mm', value: 'cigw-200' },
          { title: '240 mm', value: 'cigw-240' }
        ],
        rockwoll: [
          { title: '100 mm', value: 'cirw-100' },
          { title: '140 mm', value: 'cirw-140' },
          { title: '160 mm', value: 'cirw-160' },
          { title: '180 mm', value: 'cirw-180' },
          { title: '200 mm', value: 'cirw-200' }
        ],
        cellulose: [
          { title: '160 mm', value: 'cicf-160' }, 
          // { title: '180 mm', value: 'cicf-180' }
        ],
        woodwoll: [
          { title: '140 mm', value: 'ciww-140' },
          { title: '160 mm', value: 'ciww-160' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.glasswoll.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.rockwoll.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.cellulose.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.woodwoll.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('compartmentInsulation', value)



      let category = this.title
      if (this.items.glasswoll.some(el => el.value === value)) {
          category += '-Glaswolle'
      }
      else if ( this.items.rockwoll.some(el => el.value === value)) {
          category += '-Steinwolle'
      }
      else if ( this.items.cellulose.some(el => el.value === value)) {
          category += '-Zellulose'
      }
      else if ( this.items.woodwoll.some(el => el.value === value)) {
          category += '-Holzwolle'
      }
      


      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'compartmentInsulation',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
